import React, { useContext, useRef, useState, useEffect } from "react"
import ReactPlayer from "react-player"
import AppContext from "../../../shared/AppContext"

const videoParts = [
  {
    label: "our research",
    start: 0.0,
  },
  {
    label: "our platform",
    start: 0.23,
  },
  {
    label: "custom surveys",
    start: 0.414,
  },
  {
    label: "live insights",
    start: 0.55,
  },
  {
    label: "expert calls",
    start: 0.705,
  },
  {
    label: "reports",
    start: 0.863,
  },
]

const videoStates = {
  playing: "playing",
  paused: "paused",
  ended: "ended",
}

const videoURL = "https://www.youtube.com/embed/GDTXuqNcvUA?rel=0"

const Video = React.forwardRef((props, forwardRef) => {
  const [videoPart, setVideoPart] = useState(videoParts[0])
  const [videoState, setVideoState] = useState(null)

  const { trackEvent } = useContext(AppContext)

  const videoRef = useRef()

  const isVideoPlaying = videoState === videoStates.playing

  useEffect(() => {
    if (videoState) {
      trackEvent("demo video state change", { state: videoState })
    }
  }, [videoState])

  useEffect(() => {
    if (isVideoPlaying) {
      trackEvent(`demo video progress`, { part: videoPart })
    }
  }, [videoPart])

  const onVideoPartClick = (part) => {
    videoRef.current.seekTo(part.start)
    setVideoPart(part)
    setVideoState(videoStates.playing)
    trackEvent("demo video part click", { part })
  }

  const handleVideoProgress = (videoProgress) => {
    let i = videoParts.length
    while (i--) {
      const part = videoParts[i]
      if (videoProgress.played >= part.start) {
        setVideoPart(part)
        break
      }
    }
  }

  return (
    <div className="main-content">
      <div
        ref={forwardRef}
        id="video"
        className="demo-video-time-stamps"
        data-cy="video"
      >
        <ul className="video-time-stamps" data-cy="video-time-stamps">
          {videoParts.map((part, idx) => {
            return (
              <li
                key={idx}
                data-selected={videoPart.label === part.label}
                onClick={() => onVideoPartClick(part)}
              >
                {part.label}
              </li>
            )
          })}
        </ul>

        <div className="video-wrap">
          <ReactPlayer
            className="demo-video-iframe"
            ref={videoRef}
            playing={isVideoPlaying}
            style={{ position: "absolute", top: 0 }}
            controls
            url={videoURL}
            onProgress={handleVideoProgress}
            onPause={() => setVideoState(videoStates.paused)}
            onPlay={() => setVideoState(videoStates.playing)}
            onEnded={() => setVideoState(videoStates.ended)}
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  )
})

Video.displayName = "Video"

export default Video
